import { BASE_URL } from '@pepper/utils/src/api/config'
import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

declare interface HomeDashboardMetrics {
  average_approval_time: {
    value: number
    change: number
  }
  rework: {
    value: number
    change: number
  }
  total_assignments: {
    value: number
  }
  total_assignments_pending_approval: {
    value: number
  }
}

export const getDashboardMetrics = async (
  companyId: string
): Promise<{
  status: 'error' | 'ok'
  data: HomeDashboardMetrics
  error: string | undefined
}> => {
  const timePeriod = 7

  try {
    const response = await axios.get(
      `${BASE_URL}/analytics/dashboard_analytics?company_id=${companyId}&time_unit=DAY&time_period=${timePeriod}`
    )

    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const useDashboardMetrics = (
  companyId: string
): UseQueryResult<HomeDashboardMetrics> => {
  return useQuery({
    queryKey: ['analytics/dashboardmetrics', companyId],
    queryFn: async () => {
      const { data } = await getDashboardMetrics(companyId)
      return data
    },
  })
}
